module.exports = "/images/shopWithOutLogo.svg";